module.exports = require("react-autosuggest");